"use client";
import React, { useState, useMemo, useCallback, ReactNode } from "react";
import { gaCommonEvent } from "@/src/utils/gtagEvents";
import { FmButton, FmDialog, FmDrawer, FmToast } from "@/ui-component";
import { IProps } from ".";
import { checkProductPackageRx } from "@/lib/lens/package";
import { addToCartClickEvent } from "@/src/models/emailData";
import criteoAd from "@/src/components/LoadAnalysis/analysis/criteo";
import { useProductDetailsContext } from "@/src/provider";
const Rx = dynamic(() => import("@/src/productDetails/Rx"));
import { lensObj } from "@/store";
import dynamic from "next/dynamic";
import { useTranslation } from "@/src/i18n/client";

interface IRxClientProps extends IProps {}
const RxClient: React.FC<React.PropsWithChildren<IRxClientProps>> = (props) => {
    const { data } = props;
    const [productDetail, activeObj, packageId] = useProductDetailsContext(
        (state) => [state.productDetail, state.activeObj, state.packageId],
    );

    const { p_under_market } = productDetail;

    const { colorUnderMarket, outOfStore } = activeObj;
    const addToCartOutOf = useMemo(
        () => !!(p_under_market || colorUnderMarket || outOfStore),
        [colorUnderMarket, outOfStore, p_under_market],
    );
    const [isDecentered] = lensObj.useInstationStore((state) => [
        state.isDecentered,
    ]);
    const [rxVisible, setRxVisible] = useState(false);
    const { t } = useTranslation(["productDetail", "common", "lens"]);
    const toggerRxModal = () => {
        setRxVisible((prev) => !prev);
    };

    const [toastVisible, setToastVisible] = useState(false);
    const [toastType, setToastType] = useState<"info" | "loading">("info");
    const [dialogOpen, setDialogOpen] = useState(false);
    const [dialogTitle, setDialogTitle] = useState("");
    const [dialogChildren, setDialogChildren] = useState("");
    const [renderBottom, setRenderBottom] = useState<ReactNode>(<></>);
    const loadingToast = useCallback(() => {
        setToastType("loading");
        setToastVisible(true);
    }, []);
    const checkAdd = (rx: any, rxStr: string) => {
        setRxVisible(false);

        //渐进套餐必须输入add
        if (data.packageCategoryId == 4 && !rx.add) {
            setDialogTitle(t("common:Reminder"));
            setDialogChildren(`${t("lens:PLS_SELECT_THE")} ${t("lens:ADD")}`);
            setRenderBottom(
                <FmButton onClick={() => setRxVisible(true)}>
                    {t("common:OK")}
                </FmButton>,
            );

            return;
        }

        gaCommonEvent("pg-submit", {
            event_category: "package",
            event_label: data.displayName,
        });
        loadingToast();
        checkProductPackageRx({
            rx,
            rxStr,
            packageInfo: data,
            productInfo: productDetail,
            color_id: activeObj.id,
            page_id: packageId,
            isDecentered,
        }).then(
            () => {
                setToastVisible(false);
                addToCartClickEvent({
                    colorId: activeObj.id,
                    price: activeObj.onsale?.price,
                });
                criteoAd.addToCart({
                    id: activeObj.id,
                    price: activeObj.onsale?.price,
                    quantity: 1,
                });
                location.href = "/basket";
            },
            () => {
                setToastVisible(false);
                setDialogTitle("");
                setDialogChildren(
                    t("productDetail:PackageInfo.PrescriptionERROR"),
                );
                setRenderBottom(
                    <>
                        <FmButton
                            onClick={() => {
                                gaCommonEvent("pg-choose other", {
                                    event_category: "package",
                                    event_label: data.displayName,
                                });
                            }}
                            style={{ fontSize: "0.24rem" }}
                        >
                            {t("productDetail:PackageInfo.ChooseOthers")}
                        </FmButton>
                        <FmButton
                            onClick={() => {
                                gaCommonEvent("pg-customize", {
                                    event_category: "package",
                                    event_label: data.displayName,
                                });
                                location.href = `/lens?lensColor=${activeObj.id}&is_package=${packageId}&usage=-1&products_id=${productDetail.products_id}`;
                            }}
                            style={{ fontSize: "0.24rem" }}
                        >
                            {t("productDetail:PackageInfo.CustomizeLenses")}
                        </FmButton>
                    </>,
                );
            },
        );
    };

    return (
        <>
            {/* 这个没有东西设置为true */}
            <FmDialog
                open={dialogOpen}
                renderBottom={renderBottom}
                dialogTitle={dialogTitle}
            >
                {dialogChildren}
            </FmDialog>
            <FmToast visible={toastVisible} type={toastType} />
            <FmButton
                style={{ padding: "6px 20px" }}
                size="medium"
                disabled={addToCartOutOf}
                onClick={() => {
                    gaCommonEvent("pg-add to cart", {
                        event_category: "package",
                        event_label: data.displayName,
                    });
                    toggerRxModal();
                }}
            >
                {t(
                    addToCartOutOf
                        ? "productDetail:SOLD_OUT"
                        : "common:ADD_TO_CART",
                )}
            </FmButton>
            {/* 处方填写 */}
            <FmDrawer
                closeable
                open={rxVisible}
                onClose={toggerRxModal}
                fullHeight
                anchor="bottom"
                closeablePosition="right"
                headerChildren
            >
                {rxVisible && <Rx nextStep={checkAdd} isHideImgRx={true} />}
            </FmDrawer>
        </>
    );
};

export default RxClient;
